import { Moment } from 'moment';

export enum QuestFilterBy {
  emissionDate,
  dueDate,
  receiptDate,
}

export enum QuestSituation {
  open = 'OPEN',
  settled = 'SETTLED',
}

export interface QuestCommissionByFinancialFormValues {
  companiesIds?: number[];
  employeesIds?: number[];
  documentTypeIds?: number[];
  deduction: string;
  situation: QuestSituation;
  filterBy: QuestFilterBy;
  initialDate: Moment;
  finalDate: Moment;
}

export interface QuestCommissionByFinancialRequest {
  companiesIds?: string;
  employeesIds?: string;
  documentTypeIds?: string;
  deduction: string;
  open: boolean;
  settled: boolean;
  filterBy: QuestFilterBy;
  startDate: string;
  endDate: string;
}
